module.exports = __webpack_public_path__ + "ua.svg?bd82dfe13a2fe8f5c9223bc0410989b1";